import styled from "@emotion/styled";
import {
  createCustomSpacing,
  Grid,
  Grids,
  MediaQueries,
  PrimaryButton,
  Section,
  ShareDialogServices,
  Spacings,
  WithShareDialog,
} from "@polestar/component-warehouse-react";
import { useMemo } from "react";

const StyledSection = styled(Section)`
  margin-top: -${Spacings.xLarge};

  ${MediaQueries.desktop} {
    margin-top: -${createCustomSpacing(2.5)};
  }
`;

const StyledGrid = styled(Grid)`
  margin-bottom: ${Spacings.large};

  ${MediaQueries.tablet} {
    margin-bottom: ${Spacings.xLarge};
  }

  ${MediaQueries.desktop} {
    margin-bottom: ${Spacings.xxLarge};
  }

  ${MediaQueries.desktopWide} {
    margin-bottom: ${Spacings.xxxLarge};
  }
`;

const StyledColumn = styled.div`
  grid-column: span ${Grids.tablet.columns};

  ${MediaQueries.tablet} {
    grid-column: 1 / span ${Grids.tablet.columns};
  }

  ${MediaQueries.desktop} {
    grid-column: 3 / span ${Grids.tablet.columns};
  }

  ${MediaQueries.desktopWide} {
    grid-column: 5 / span 6;
  }
`;

interface Props {
  readonly copyLabel?: string;
  readonly buttonLabel: string;
  readonly emailLabel: string;
}

const NewsShareButton = ({ emailLabel, copyLabel, buttonLabel }: Props) => {
  const dialogItems = useMemo(() => {
    const items = [
      { label: "Twitter", serviceType: ShareDialogServices.twitter },
      { label: "Facebook", serviceType: ShareDialogServices.facebook },
      { label: "LinkedIn", serviceType: ShareDialogServices.linkedIn },
      {
        label: emailLabel,
        serviceType: ShareDialogServices.email,
      },
    ];
    if (copyLabel) {
      items.push({
        label: `${copyLabel[0].toUpperCase()}${copyLabel.slice(1)}`,
        serviceType: ShareDialogServices.copy,
      });
    }

    return items;
  }, [emailLabel, copyLabel]);

  return (
    <StyledSection>
      <StyledGrid>
        <StyledColumn>
          <WithShareDialog items={dialogItems}>
            <PrimaryButton icon={false}>{buttonLabel}</PrimaryButton>
          </WithShareDialog>
        </StyledColumn>
      </StyledGrid>
    </StyledSection>
  );
};

export default NewsShareButton;
